import Vue from "vue";
import Vuex from "vuex";
import { account } from "@/https/login";

import router from "@/router";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeIndex: 0,
    userInfo: localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {},
    msgResource: {},
    allMessageInfo: {},
  },
  mutations: {
    changeActive(state, props) {
      sessionStorage.setItem("activeIndex", props);
      state.activeIndex = props;
    },
    setUser(state, user) {
      state.userInfo = user;
    },
    changeMsgResource(state, resource) {
      state.msgResource = resource;
    },
    changeAllMSGInfo(state, allMsgInfo) {
      state.allMessageInfo = allMsgInfo;
    },
  },
  actions: {
    incrementAsync({ commit }) {
      setTimeout(() => {
        commit("increment");
      }, 1000);
    },
    
    logout({ commit }) {
      return new Promise((resolve) => {
        // 模拟异步登出
        setTimeout(() => {
          commit("setUser", null);
          resolve();
        }, 500);
      });
    },
  },
  getters: {
    doubleCount: (state) => state.count * 2,
    isAuthenticated: (state) => !!state.user,
  },
  modules: {},
});
